// Maps the font slugs saved by the dashboard (FONT_OPTIONS in
// dashboard/features/settings/pages/Branding.tsx) to real CSS font-family
// stacks. Keep in sync with that list.
const FONT_FAMILY_MAP: Record<string, string> = {
  inherit: 'inherit',
  arial: 'Arial, Helvetica, sans-serif',
  roboto: "'Roboto', sans-serif",
  'open-sans': "'Open Sans', sans-serif",
  lato: "'Lato', sans-serif",
  georgia: 'Georgia, serif',
  impact: 'Impact, sans-serif',
  'times-new-roman': "'Times New Roman', Times, serif",
  montserrat: "'Montserrat', sans-serif",
  verdana: 'Verdana, Geneva, sans-serif',
  helvetica: 'Helvetica, Arial, sans-serif',
  'trebuchet-ms': "'Trebuchet MS', Helvetica, sans-serif",
  garamond: "'Garamond', 'Times New Roman', serif",
};

// Unset, empty, or unknown slug -> 'inherit' (opt into the host page's font).
export const getFontFamily = (slug?: string | null): string =>
  (slug && FONT_FAMILY_MAP[slug]) || 'inherit';
